import axios from 'axios';

const API = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:3100').replace(/\/api\/v\d+\/?$/, '');
const BASE = `${API}/api/v1`;
// NetSuite integration service is proxied via gateway under /netsuite prefix
const NS = `${BASE}/netsuite`;

function authHeaders() {
  return { Authorization: `Bearer ${localStorage.getItem('token')}` };
}

// ── Health & Monitoring ──────────────────────────────────────────────────────

export async function getIntegrationHealth() {
  const res = await axios.get(`${NS}/monitoring/health`, { headers: authHeaders() });
  return res.data;
}

export async function getIntegrationStatus() {
  const res = await axios.get(`${NS}/monitoring/status`, { headers: authHeaders() });
  return res.data;
}

export async function getIntegrationMetrics() {
  const res = await axios.get(`${NS}/monitoring/metrics`, { headers: authHeaders() });
  return res.data;
}

export async function getHealthReport() {
  const res = await axios.get(`${NS}/monitoring/report`, { headers: authHeaders() });
  return res.data;
}

export async function getMonitoringAlerts() {
  const res = await axios.get(`${NS}/monitoring/alerts`, { headers: authHeaders() });
  return res.data;
}

// ── Integration Stats & Logs ─────────────────────────────────────────────────

export async function getIntegrationStats() {
  const res = await axios.get(`${NS}/integration/stats`, { headers: authHeaders() });
  return res.data;
}

export async function getIntegrationLogs(type?: string, limit = 100) {
  const params: any = { limit };
  if (type) params.type = type;
  const res = await axios.get(`${NS}/integration/logs`, { params, headers: authHeaders() });
  return res.data;
}

export async function getLogByExternalId(externalId: string) {
  const res = await axios.get(`${NS}/integration/logs/${externalId}`, { headers: authHeaders() });
  return res.data;
}

export async function retryFailedJobs() {
  const res = await axios.post(`${NS}/integration/retry-failed`, {}, { headers: authHeaders() });
  return res.data;
}

// ── Sync Operations ──────────────────────────────────────────────────────────

export async function syncAllItems() {
  const res = await axios.post(`${NS}/sync/master-data/items`, {}, { headers: authHeaders() });
  return res.data;
}

export async function syncAllLocations() {
  const res = await axios.post(`${NS}/sync/master-data/locations`, {}, { headers: authHeaders() });
  return res.data;
}

export async function syncFullMasterData() {
  const res = await axios.post(`${NS}/sync/master-data/full`, {}, { headers: authHeaders() });
  return res.data;
}

export async function syncSalesOrders() {
  const res = await axios.post(`${NS}/sync/netsuite-to-mes/sales-orders`, {}, { headers: authHeaders() });
  return res.data;
}

export async function syncPurchaseOrders() {
  const res = await axios.post(`${NS}/sync/netsuite-to-mes/purchase-orders`, {}, { headers: authHeaders() });
  return res.data;
}

export async function getSyncStatus(syncType: string) {
  const res = await axios.get(`${NS}/sync/master-data/status/${syncType}`, { headers: authHeaders() });
  return res.data;
}

// ── Configuration ─────────────────────────────────────────────────────────────

export async function getNetsuiteConfig() {
  const res = await axios.get(`${NS}/config`, { headers: authHeaders() });
  return res.data;
}

export async function saveNetsuiteConfig(config: Record<string, any>) {
  const res = await axios.post(`${NS}/config`, config, { headers: authHeaders() });
  return res.data;
}

export async function testNetsuiteConnection() {
  const res = await axios.post(`${NS}/health/test`, {}, { headers: authHeaders() });
  return res.data;
}

// ── Production Performance ────────────────────────────────────────────────────

export async function exportProductionPerformance(from: string, to: string) {
  const res = await axios.get(`${NS}/production-performance`, {
    params: { from, to },
    headers: authHeaders(),
  });
  return res.data;
}
